var map = {
	"./Ostaslaufur.jpg": 5776,
	"./Skinkuhorn.jpg": 8103,
	"./fjolkornarunstk.JPG": 3259,
	"./fínt_rúnstk.JPG": 7544,
	"./heilhveitihorn.JPG": 7652,
	"./karrýbolla.jpeg": 5111,
	"./kjallarabolla.JPG": 4770,
	"./kringla.JPG": 5726,
	"./muslibolla.jpeg": 1462,
	"./olfusbolla.JPG": 8473,
	"./ostabolla.JPG": 5317,
	"./pítsaslaufa.jpg": 9664,
	"./sýslumanns.JPG": 6567
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7579;